import Markdown from 'markdown-to-jsx'
import React from 'react'
import cx from 'classnames'

import { getImageUrl } from 'utils/image'
import classNames from 'classnames'

interface MarkdownContentProps {
  children: string
  increasedMargins?: boolean
}

export const MarkdownContent = ({
  children,
  increasedMargins,
}: MarkdownContentProps) => {
  return (
    <Markdown
      options={{
        wrapper: React.Fragment,
        overrides: {
          h1: {
            props: {
              className:
                'text-2xl md:text-3xl font-normal font-body text-cool-800 mb-2 mt-6 first:mt-0 last:mb-0 tracking-normal',
            },
          },
          h2: {
            props: {
              className:
                'text-lg leading-8 font-normal font-body text-cool-800 mb-2.5 mt-6 first:mt-0 last:mb-0 tracking-normal',
            },
          },
          h3: {
            props: {
              className: classNames(
                'text-xl md:text-2xl font-normal font-body text-cool-800 first:mt-0 last:mb-0 tracking-normal mt-6',
                increasedMargins ? 'mb-4 lg:mb-6' : 'mb-2.5'
              ),
            },
          },
          h4: {
            props: {
              className:
                'text-base leading-7 md:leading-8 md:text-xl font-normal font-body text-cool-800 mb-1.5 mt-6 first:mt-0 last:mb-0 tracking-normal',
            },
          },
          p: {
            props: {
              className:
                'text-sm leading-6 sm:leading-7 sm:text-base font-normal font-body text-cool-800 mb-2.5 first:mt-0 last:mb-0',
            },
          },
          img: {
            component: ({ alt, src, ...props }) => {
              return (
                <div
                  className={classNames(
                    'mx-auto w-full max-w-full',
                    increasedMargins ? 'my-12 lg:my-14' : 'my-8 sm:my-10'
                  )}
                >
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    {...props}
                    src={getImageUrl(src, 'large')}
                    alt={alt}
                    className='w-full mb-3 max-h-[1000px]'
                  />
                  {alt && (
                    <span className='block text-center text-sm italic text-cool-700'>
                      {alt}
                    </span>
                  )}
                </div>
              )
            },
            props: {
              className: 'mx-auto mb-3 max-w-full',
            },
          },
          a: {
            props: {
              className: 'text-secondary-default underline',
              target: '_blank',
            },
          },
          ul: {
            props: {
              className: 'list-disc list-inside pl-4 mb-6 first:mt-0 last:mb-0',
            },
          },
          li: {
            props: {
              className: 'text-base font-normal font-body text-cool-800',
            },
          },
        },
      }}
    >
      {children}
    </Markdown>
  )
}
